import { get, put, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getSchemaExchangeRates = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/schema-exchange-rates`);
};

const getFees = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/fees`);
};

const getOfferFeeCatalogNegotiationData = (documentId, siteId) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/fees-negotiation-data`, { documentId, siteId });
};

const updateOfferFeeCatalog = (documentId, siteId, fees) => {
  return put(`${url}/leasingoffers/${documentId}/${siteId}/fees`, { documentId, siteId, fees });
};

const startNegotiation = (documentId, siteId, negotiationType) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/${negotiationType}/fees-start-negotiation`, {
    documentId,
    siteId,
    negotiationType
  });
};

const confirmNegotiation = (documentId, siteId) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/confirm-negotiation`, { documentId, siteId });
};

const confirmPartnerNegotiation = (documentId, siteId) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/confirm-partner-negotiation`, { documentId, siteId });
};

const confirmPartnerGroupNegotiation = (documentId, siteId) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/confirm-partner-group-negotiation`, { documentId, siteId });
};

const sendNegotiationForApproval = (documentId, siteId, fees) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/fees-send-negotiation-for-approval`, {
    documentId,
    siteId,
    fees
  });
};

const updateOfferFeeApproval1 = (documentId, siteId, schemaDetailId, didApprove) => {
  return post(`${url}/leasingoffers/income-schema-approval1`, { documentId, siteId, schemaDetailId, didApprove });
};

const updateOfferFeeApproval2 = (documentId, siteId, schemaDetailId, didApprove) => {
  return post(`${url}/leasingoffers/income-schema-approval2`, { documentId, siteId, schemaDetailId, didApprove });
};

const exp = {
  getSchemaExchangeRates,
  getFees,
  updateOfferFeeCatalog,
  updateOfferFeeApproval1,
  updateOfferFeeApproval2,
  getOfferFeeCatalogNegotiationData,
  startNegotiation,
  sendNegotiationForApproval,
  confirmNegotiation,
  confirmPartnerNegotiation,
  confirmPartnerGroupNegotiation
};
export default exp;
